import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    account_credit: 0.00,
    account_balance: 0.00,
  });

  const state = initialState();
  const getters = {
  }
  const mutations = {
    SET_ACCOUNT_CREDIT : (state, value) => {
      state.account_credit = value;
    },
    SET_ACCOUNT_BALANCE : (state, value) => {
      state.account_balance = value;
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    },
  }
  const actions = {
    ADD_ACCOUNT_CREDIT_VIA_PAYPAL : ( context, amount ) => {
      return Promise.try( () => {
        return Axios.get(`billing/addPaypalCredits/${amount}`)
      })
    },
    GET_ACCOUNT_CREDIT : ( context ) => {
      return Promise.try( () => {
        return Axios.get(`billing/credit`)
      }).then( (credit) => {
        context.commit('SET_ACCOUNT_CREDIT', credit.data);
        return
      })
    },
    GET_ACCOUNT_BALANCE : ( context ) => {
      return Promise.try( () => {
        return Axios.get(`billing/balance`)
      }).then( (balance) => {
        context.commit('SET_ACCOUNT_BALANCE', balance.data);
        return
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
